import { render } from "./GenderSection.vue?vue&type=template&id=26c7b59e"
import script from "./GenderSection.vue?vue&type=script&lang=js"
export * from "./GenderSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__